//#region src/integration_system.ts
var IntegrationSystem = /* @__PURE__ */ function(IntegrationSystem) {
	IntegrationSystem[IntegrationSystem["Omnivore"] = 1] = "Omnivore";
	IntegrationSystem[IntegrationSystem["Olo"] = 6] = "Olo";
	IntegrationSystem[IntegrationSystem["Punchh"] = 8] = "Punchh";
	IntegrationSystem[IntegrationSystem["Smg"] = 9] = "Smg";
	IntegrationSystem[IntegrationSystem["Salido"] = 10] = "Salido";
	/** @deprecated */
	IntegrationSystem[IntegrationSystem["BreadcrumbDeprecated"] = 13] = "BreadcrumbDeprecated";
	IntegrationSystem[IntegrationSystem["Revel"] = 14] = "Revel";
	IntegrationSystem[IntegrationSystem["CardConnect"] = 15] = "CardConnect";
	IntegrationSystem[IntegrationSystem["Tcc"] = 16] = "Tcc";
	IntegrationSystem[IntegrationSystem["PaytronixOlo"] = 17] = "PaytronixOlo";
	IntegrationSystem[IntegrationSystem["SquarePos"] = 19] = "SquarePos";
	IntegrationSystem[IntegrationSystem["Worldpay"] = 20] = "Worldpay";
	IntegrationSystem[IntegrationSystem["QsrAutomations"] = 22] = "QsrAutomations";
	IntegrationSystem[IntegrationSystem["ParBrink"] = 23] = "ParBrink";
	IntegrationSystem[IntegrationSystem["PunchhOlo"] = 25] = "PunchhOlo";
	IntegrationSystem[IntegrationSystem["Givex"] = 26] = "Givex";
	IntegrationSystem[IntegrationSystem["SessionMOlo"] = 27] = "SessionMOlo";
	IntegrationSystem[IntegrationSystem["Toast"] = 28] = "Toast";
	IntegrationSystem[IntegrationSystem["Heartland"] = 29] = "Heartland";
	IntegrationSystem[IntegrationSystem["Infor"] = 30] = "Infor";
	IntegrationSystem[IntegrationSystem["Archer"] = 31] = "Archer";
	IntegrationSystem[IntegrationSystem["AtriumStoredValue"] = 32] = "AtriumStoredValue";
	IntegrationSystem[IntegrationSystem["ParBrinkLoyaltyEarner"] = 33] = "ParBrinkLoyaltyEarner";
	IntegrationSystem[IntegrationSystem["PinataPos"] = 34] = "PinataPos";
	IntegrationSystem[IntegrationSystem["PinataLoyalty"] = 35] = "PinataLoyalty";
	IntegrationSystem[IntegrationSystem["Stripe"] = 36] = "Stripe";
	IntegrationSystem[IntegrationSystem["FreedomPayFlash"] = 37] = "FreedomPayFlash";
	IntegrationSystem[IntegrationSystem["Twilio"] = 38] = "Twilio";
	IntegrationSystem[IntegrationSystem["PinataNotifier"] = 39] = "PinataNotifier";
	IntegrationSystem[IntegrationSystem["Como"] = 40] = "Como";
	IntegrationSystem[IntegrationSystem["FreedomPayKiosk"] = 41] = "FreedomPayKiosk";
	IntegrationSystem[IntegrationSystem["PinataStoredValue"] = 42] = "PinataStoredValue";
	IntegrationSystem[IntegrationSystem["Valutec"] = 43] = "Valutec";
	IntegrationSystem[IntegrationSystem["PaytronixGift"] = 44] = "PaytronixGift";
	IntegrationSystem[IntegrationSystem["NcrRadiant"] = 45] = "NcrRadiant";
	IntegrationSystem[IntegrationSystem["Vicki"] = 48] = "Vicki";
	IntegrationSystem[IntegrationSystem["PaytronixLoyalty"] = 49] = "PaytronixLoyalty";
	IntegrationSystem[IntegrationSystem["NcrAloha"] = 50] = "NcrAloha";
	IntegrationSystem[IntegrationSystem["Elavon"] = 51] = "Elavon";
	IntegrationSystem[IntegrationSystem["Incentivio"] = 52] = "Incentivio";
	IntegrationSystem[IntegrationSystem["Otter"] = 53] = "Otter";
	IntegrationSystem[IntegrationSystem["Sprinkles"] = 54] = "Sprinkles";
	IntegrationSystem[IntegrationSystem["Simphony"] = 55] = "Simphony";
	IntegrationSystem[IntegrationSystem["VerifonePointCloud"] = 56] = "VerifonePointCloud";
	IntegrationSystem[IntegrationSystem["LogicControls"] = 57] = "LogicControls";
	IntegrationSystem[IntegrationSystem["OloPayKioskOrderingApi"] = 58] = "OloPayKioskOrderingApi";
	IntegrationSystem[IntegrationSystem["PDI"] = 59] = "PDI";
	IntegrationSystem[IntegrationSystem["StripeTerminal"] = 60] = "StripeTerminal";
	IntegrationSystem[IntegrationSystem["Eigen"] = 61] = "Eigen";
	IntegrationSystem[IntegrationSystem["Adyen"] = 62] = "Adyen";
	IntegrationSystem[IntegrationSystem["SpotOn"] = 63] = "SpotOn";
	IntegrationSystem[IntegrationSystem["PinataFulfillment"] = 64] = "PinataFulfillment";
	IntegrationSystem[IntegrationSystem["IQTouch"] = 65] = "IQTouch";
	IntegrationSystem[IntegrationSystem["ComoEarner"] = 66] = "ComoEarner";
	IntegrationSystem[IntegrationSystem["VerifonePointSca"] = 67] = "VerifonePointSca";
	IntegrationSystem[IntegrationSystem["Sparkfly"] = 68] = "Sparkfly";
	IntegrationSystem[IntegrationSystem["WorldpayStoredValue"] = 69] = "WorldpayStoredValue";
	IntegrationSystem[IntegrationSystem["OloStoredValue"] = 70] = "OloStoredValue";
	IntegrationSystem[IntegrationSystem["CheetahOloLoyalty"] = 71] = "CheetahOloLoyalty";
	IntegrationSystem[IntegrationSystem["Lunchbox"] = 72] = "Lunchbox";
	IntegrationSystem[IntegrationSystem["FreshKDS"] = 73] = "FreshKDS";
	IntegrationSystem[IntegrationSystem["ThanxOlo"] = 74] = "ThanxOlo";
	IntegrationSystem[IntegrationSystem["ComoOlo"] = 75] = "ComoOlo";
	IntegrationSystem[IntegrationSystem["EigenStoredValue"] = 76] = "EigenStoredValue";
	IntegrationSystem[IntegrationSystem["LoyaltyPlantEarner"] = 77] = "LoyaltyPlantEarner";
	IntegrationSystem[IntegrationSystem["PaytronixCompCard"] = 78] = "PaytronixCompCard";
	IntegrationSystem[IntegrationSystem["PeetsPaytronixOlo"] = 79] = "PeetsPaytronixOlo";
	IntegrationSystem[IntegrationSystem["ChoptLoyalty"] = 80] = "ChoptLoyalty";
	IntegrationSystem[IntegrationSystem["PinataCompCard"] = 81] = "PinataCompCard";
	IntegrationSystem[IntegrationSystem["PinataPay"] = 82] = "PinataPay";
	IntegrationSystem[IntegrationSystem["PinataPayStoredValue"] = 83] = "PinataPayStoredValue";
	IntegrationSystem[IntegrationSystem["Attentive"] = 84] = "Attentive";
	IntegrationSystem[IntegrationSystem["LovesRewards"] = 85] = "LovesRewards";
	IntegrationSystem[IntegrationSystem["Qu"] = 86] = "Qu";
	IntegrationSystem[IntegrationSystem["FreedomPayKioskStoredValue"] = 87] = "FreedomPayKioskStoredValue";
	IntegrationSystem[IntegrationSystem["PinataPayNative"] = 88] = "PinataPayNative";
	IntegrationSystem[IntegrationSystem["PinataPayNativeStoredValue"] = 89] = "PinataPayNativeStoredValue";
	IntegrationSystem[IntegrationSystem["LrsTableTracker"] = 91] = "LrsTableTracker";
	IntegrationSystem[IntegrationSystem["OloPayKioskPaymentApi"] = 92] = "OloPayKioskPaymentApi";
	IntegrationSystem[IntegrationSystem["Thanx"] = 93] = "Thanx";
	IntegrationSystem[IntegrationSystem["ParPay"] = 94] = "ParPay";
	IntegrationSystem[IntegrationSystem["ParPayStoredValue"] = 95] = "ParPayStoredValue";
	IntegrationSystem[IntegrationSystem["AurusPay"] = 96] = "AurusPay";
	IntegrationSystem[IntegrationSystem["AurusPayStoredValue"] = 97] = "AurusPayStoredValue";
	IntegrationSystem[IntegrationSystem["Chase"] = 98] = "Chase";
	IntegrationSystem[IntegrationSystem["ChaseStoredValue"] = 99] = "ChaseStoredValue";
	IntegrationSystem[IntegrationSystem["Deliverect"] = 100] = "Deliverect";
	IntegrationSystem[IntegrationSystem["SmoothCommerce"] = 101] = "SmoothCommerce";
	IntegrationSystem[IntegrationSystem["Spendgo"] = 102] = "Spendgo";
	IntegrationSystem[IntegrationSystem["Vibes"] = 103] = "Vibes";
	IntegrationSystem[IntegrationSystem["Moneris"] = 104] = "Moneris";
	IntegrationSystem[IntegrationSystem["LoyaltyPlant"] = 105] = "LoyaltyPlant";
	IntegrationSystem[IntegrationSystem["StarbucksPayAndEarnLoyalty"] = 106] = "StarbucksPayAndEarnLoyalty";
	IntegrationSystem[IntegrationSystem["AtriumLoyalty"] = 108] = "AtriumLoyalty";
	IntegrationSystem[IntegrationSystem["StarbucksPos"] = 109] = "StarbucksPos";
	IntegrationSystem[IntegrationSystem["Jtech"] = 110] = "Jtech";
	IntegrationSystem[IntegrationSystem["PinataTableTracker"] = 111] = "PinataTableTracker";
	IntegrationSystem[IntegrationSystem["StarbucksFullLoyalty"] = 112] = "StarbucksFullLoyalty";
	IntegrationSystem[IntegrationSystem["PinataCashMachine"] = 113] = "PinataCashMachine";
	IntegrationSystem[IntegrationSystem["Glory"] = 114] = "Glory";
	IntegrationSystem[IntegrationSystem["LovesPos"] = 115] = "LovesPos";
	IntegrationSystem[IntegrationSystem["SparkflyLoyaltyEarner"] = 116] = "SparkflyLoyaltyEarner";
	IntegrationSystem[IntegrationSystem["CbordCampusCard"] = 117] = "CbordCampusCard";
	IntegrationSystem[IntegrationSystem["PinataCampusCard"] = 118] = "PinataCampusCard";
	IntegrationSystem[IntegrationSystem["DeliverectCommerce"] = 119] = "DeliverectCommerce";
	IntegrationSystem[IntegrationSystem["ParPosDataSource"] = 120] = "ParPosDataSource";
	IntegrationSystem[IntegrationSystem["VerifoneCommander"] = 121] = "VerifoneCommander";
	IntegrationSystem[IntegrationSystem["QuickchargeCampusCard"] = 122] = "QuickchargeCampusCard";
	IntegrationSystem[IntegrationSystem["Qualtrics"] = 123] = "Qualtrics";
	IntegrationSystem[IntegrationSystem["StarbucksStoredValue"] = 124] = "StarbucksStoredValue";
	IntegrationSystem[IntegrationSystem["FreedomPayStoredValue"] = 125] = "FreedomPayStoredValue";
	IntegrationSystem[IntegrationSystem["Appfront"] = 126] = "Appfront";
	IntegrationSystem[IntegrationSystem["TransactCampusCard"] = 127] = "TransactCampusCard";
	IntegrationSystem[IntegrationSystem["OloAccountsLoyalty"] = 128] = "OloAccountsLoyalty";
	IntegrationSystem[IntegrationSystem["AtriumCampusCard"] = 129] = "AtriumCampusCard";
	IntegrationSystem[IntegrationSystem["SpendgoOlo"] = 130] = "SpendgoOlo";
	IntegrationSystem[IntegrationSystem["GivexLoyalty"] = 131] = "GivexLoyalty";
	IntegrationSystem[IntegrationSystem["ECardSystems"] = 132] = "ECardSystems";
	return IntegrationSystem;
}(IntegrationSystem || {});
//#endregion
export { IntegrationSystem };

//# sourceMappingURL=integration_system.js.map